module.exports = "/images/banregio.svg?f8e626363c57e50efe55ed2074cfcea7";